import * as React from "react";
import { UitkCard } from "@egencia/uitk-react";
import { FaqFeedback } from "./faq-feedback";

export function ArticleDetails({ article, topic }) {
    const hasUser = !!EG.user;
    return (
        <UitkCard className="cms-body" padding={"medium"}>
            <div dangerouslySetInnerHTML={{__html: article.body}}/>
            <FaqFeedback article={article} topic={topic} hasUser={hasUser}/>
        </UitkCard>
    )
}